import { Theme } from '@constants';

export const tPath = 'videoControls';

export const LAYOUT_OFFSET = Theme.px(959);

// Layout constants for VODVideoControls component
export const Layout = {
  leftMargin: Theme.px(90),
  rightMargin: Theme.px(118),
  topMargin: Theme.px(630),
  scheduleTextSpacing: Theme.px(6),
  vodProgressBarWidth: Theme.px(1600),
  vodProgressBarHeight: Theme.px(12),
};
